import Card from '../../shared/Card';
import Header from '../../shared/Header';
import { Stack } from '../../shared/layouts';
import OverviewDetailRow from '../../shared/OverviewDetailRow';
import FileAttachmentButton from '../../shared/FileAttachmentButton';
import LonelyPlaceholder from '../../shared/LonelyPlaceholder';
import { useTranslation } from 'react-i18next';
import AdvisorDetails from '../../shared/AdvisorDetails';

const FuneralInsuranceCard = ({
  insurance: {
    uuid,
    company,
    product_description,
    policy_number,
    start_date,
    insuree = [],
    product_name,
    advisor = {},
  },
  index,
  isMinDesktop,
  connectedFiles
}) => {
  const packageFiles = connectedFiles?.[uuid] || [];
  const { t } = useTranslation();

  return (
    <Card fontSize={isMinDesktop ? 'm' : 's'}>
      <Stack space={isMinDesktop ? 'l' : 'm'}>
        <Header
          title={`${company || ''} ${product_name ||
            t('Uitvaartverzekering') + ` ` + (index + 1)}`}
          variant="section"
          fontSize={isMinDesktop ? 'l' : 's'}
        />
        <div>
          <b>{t('Algemene gegevens') + `:`}</b>
          <Stack space={'none'} divider={'default'}>
            <OverviewDetailRow
              descriptor={t('Maatschappij')}
              value={company}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Product')}
              value={product_name}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Polisnummer')}
              value={policy_number}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Startdatum')}
              value={start_date}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Omschrijving')}
              value={product_description}
              hideIfEmpty
            />
            {insuree?.length === 0 && <LonelyPlaceholder />}
          </Stack>
        </div>

        {insuree?.length > 0 && (
          <div>
            <b>{t('Verzekerden') + `:`}</b>
            <Stack space={'none'} divider={'default'}>
              {insuree.map(name => (
                <OverviewDetailRow
                  key={name}
                  descriptor={t('Verzekerde')}
                  value={name}
                  hideIfEmpty
                />
              ))}
            </Stack>
          </div>
        )}

        {packageFiles?.length > 0 && (
          <div>
            <b>{t('Document(en)') + `:`}</b>
            <Stack space={'s'} mt={'s'}>
              {packageFiles.map(({ name, download_url }) => (
                <FileAttachmentButton
                  key={name}
                  fileName={name}
                  fileUrl={download_url}
                />
              ))}
            </Stack>
          </div>
        )}

        {Object.keys(advisor).length > 0 && <AdvisorDetails {...advisor} />}
      </Stack>
    </Card>
  );
};

export default FuneralInsuranceCard;
